// import { useNavigate, useParams } from 'react-router-dom';

import Home from "./Frontend/Home";

function App() {
  return (
    <div>
      <Home />
    </div>
  );
}

export default App;
